import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ApiError } from 'src/api/axiosClient/types';
import { RootState } from 'src/store';
import { GetGroupsParams, Group } from '../types';
import { GroupsState } from './types';

const initialState: GroupsState = {
  loading: {
    getList: false,
    getById: false,
    archive: false,
    unarchive: false,
    addContactsToGroup: false,
    removeContactsFromGroup: false,
    create: false,
    update: false,
    delete: false,
    testGroupRules: false,
  },
  filter: {
    companyId: '',
    offset: 0,
    limit: 25,
    page: 0,
  },
  list: null,
  group: null,
  error: null,
};

const groupsSlice = createSlice({
  name: 'groups',
  initialState,
  reducers: {
    setLoading: (
      state,
      action: PayloadAction<Partial<Record<keyof GroupsState['loading'], boolean>>>,
    ) => {
      state.loading = { ...state.loading, ...action.payload };
    },
    setFilter(state, action: PayloadAction<Partial<GetGroupsParams>>) {
      state.filter = {
        ...state.filter,
        ...action.payload,
      };
    },
    setList: (
      state,
      action: PayloadAction<{
        items: Group[];
        count: number;
      }>,
    ) => {
      state.list = action.payload;
    },
    setGroup: (state, action: PayloadAction<Group>) => {
      state.group = action.payload;
    },
    setError: (state, action: PayloadAction<ApiError>) => {
      state.error = action.payload;
    },
    resetList: state => {
      state.filter = initialState.filter;
      state.list = initialState.list;
    },
    resetGroup: state => {
      state.group = initialState.group;
    },
    resetError: state => {
      state.error = initialState.error;
    },
    resetSlice: () => {
      initialState;
    },
  },
});

export const isGroupsLoading = (state: RootState) => state.groups.loading;

export const getGroups = (state: RootState) => state.groups.list;

export const getGroup = (state: RootState) => state.groups.group;

export const isGroupsError = (state: RootState) => state.groups.error;

export const {
  setLoading,
  setFilter,
  setList,
  setGroup,
  setError,
  resetList,
  resetGroup,
  resetError,
  resetSlice,
} = groupsSlice.actions;

export const groupsReducer = groupsSlice.reducer;
